if (!customElements.get('case-carousel')) {
  customElements.define(
    'case-carousel',
    class CaseCarousel extends HTMLElement {
      constructor() {
        super();
        this.viewportNode = this.querySelector('.case-carousel__slider-viewport');
        this.prevBtnNode = this.querySelector('.case-carousel__prev');
        this.nextBtnNode = this.querySelector('.case-carousel__next');
        this.slides = this.querySelectorAll('.case-carousel__slide');
        this.images = this.querySelectorAll('.case__image');

        this.embla = EmblaCarousel(this.viewportNode, {
          align: 'center',
          slidesToScroll: 1,
          loop: true,
          watchDrag: false,
        });

        this.slides.forEach((slide, index) => {
          slide.addEventListener('click', () => {
            this.embla.scrollTo(index);
            this.images[index].click();
          });
        });

        this.prevBtnNode.addEventListener('click', this.previous.bind(this), false);
        this.nextBtnNode.addEventListener('click', this.next.bind(this), false);

        this.embla
          .on('select', this.togglePrevNextBtnsState.bind(this))
          .on('init', this.togglePrevNextBtnsState.bind(this))
          .on('reInit', this.togglePrevNextBtnsState.bind(this));
      }

      previous(e) {
        e.preventDefault();
        this.embla.scrollPrev();
      }

      next(e) {
        e.preventDefault();
        this.embla.scrollNext();
      }

      togglePrevNextBtnsState() {
        const selectedIndex = this.embla.selectedScrollSnap();
        this.images[selectedIndex].click();

        if (this.embla.canScrollPrev()) {
          this.prevBtnNode.classList.remove('arrow-button--disabled');
        } else {
          this.prevBtnNode.classList.add('arrow-button--disabled');
        }

        if (this.embla.canScrollNext()) {
          this.nextBtnNode.classList.remove('arrow-button--disabled');
        } else {
          this.nextBtnNode.classList.add('arrow-button--disabled');
        }
      }
    },
  );
}
